import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidator } from 'src/app/helpers/custom.validator';

import { Patterns } from 'src/app/helpers/patterns';
import { AuthUser } from 'src/app//shared/models/auth/AuthUser';
import { Lookup } from 'src/app//shared/models/lookups/Lookup';
import { PersonalData } from 'src/app//shared/models/support-ticket/PersonalData';
import { SupportTicketForm } from 'src/app//shared/models/support-ticket/SupportTicketForm';
import { SubmissionType } from 'src/app//shared/models/support-ticket/enums/SubmissionType.enum';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

import { SupportTicketService } from 'src/app/shared/services/support-ticket.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';

export interface DialogData {

}

@Component({
  selector: 'app-support-ticket-form',
  templateUrl: './support-ticket-form.component.html'
})
export class SupportTicketFormComponent implements OnInit {
  currentUser: AuthUser | null = new AuthUser();
  captcha = '';
  dataLoading = false;
  loading = false;
  formGroup!: FormGroup;
  isSubmitted = false;

  roleList: Lookup[] = [];
  roleListLoading = false;
  submissionTypeList = [
    { name: 'supportTicket.suggestion', value: SubmissionType.Suggestion },
    { name: 'supportTicket.complaint', value: SubmissionType.Complaint }
  ];
  catergoryList: Lookup[] = [];
  catergoryListLoading = false;
  // Attachments
  DeletedOtherAttachments: number[] = [];
  attachments = [];
  allowedExt = ['jpeg', 'jpg', 'png', 'pdf', 'mp4'];
  hideCaptcha = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<SupportTicketFormComponent>,
    private formBuilder: FormBuilder,
    private service: SupportTicketService,
    private auth: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private el: ElementRef
  ) {
    this.currentUser = this.auth.currentUserValue;
  }

  ngOnInit(): void {
    const notNeedCaptcha = [
      'https://gh.ebssar.com'
    ];
    const hideCaptcha = [
      'https://gh.ebssar.com'
    ];
    if (notNeedCaptcha.includes(location.origin) || this.currentUser) {
      this.captcha = 'ay 7aga';
    }
    if (hideCaptcha.includes(location.origin)) {
      this.hideCaptcha = true;
    }
    this.buildForm();
    this.getRoles();
    this.getSupportTicketCategory();
    if (this.currentUser) {
      this.getPersonalData();
    }
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      isAnonymous: [false],
      name: [null, [CustomValidator.noWhiteSpace, Validators.maxLength(50)]],
      email: [
        null,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(Patterns.email),
        ],
      ],
      role: [null, this.currentUser ? [Validators.required] : null],
      submissionType: [SubmissionType.Suggestion],
      supportRequestCategoryId: [null, [Validators.required]],
      description: [null, [Validators.required, Validators.maxLength(500)]],
    });
  }

  getPersonalData() {
    this.dataLoading = true;
    this.service.getPersonalData().subscribe(
      (data: PersonalData) => {
        this.dataLoading = false;
        if (data) {
          this.bindDataToUpdate(data);
        }
      },
      (error: any) => {
        this.dataLoading = false;
      }
    );
  }

  bindDataToUpdate(record: PersonalData) {
    this.formGroup.controls['name'].setValue(record.name);
    this.formGroup.controls['email'].setValue(record.email);
    this.formGroup.controls['role'].setValue(record.role);
  }

  getRoles() {
    this.roleListLoading = true;
    this.service.getRoles().subscribe(
      (data: any) => {
        this.roleList = data as [];
        this.roleListLoading = false;
      }, (err: any) => {
        console.error(err);
        this.roleListLoading = false;
      });
  }

  getSupportTicketCategory() {
    this.catergoryListLoading = true;
    this.service.getSupportTicketCategory(this.formGroup.controls['submissionType'].value).subscribe(
      (data: any) => {
        this.catergoryList = data as [];
        this.catergoryListLoading = false;
        this.formGroup.controls['supportRequestCategoryId'].setValue(null);
      }, (err: any) => {
        console.error(err);
        this.catergoryListLoading = false;
      });
  }

  changeAnonymousToggle(e: MatSlideToggleChange) {
    if (e && e.checked) {
      this.formGroup.controls['name'].clearValidators();
      this.formGroup.controls['email'].clearValidators();
      this.formGroup.controls['role'].clearValidators();
    } else {
      this.formGroup.controls['name'].setValidators([CustomValidator.noWhiteSpace, Validators.maxLength(50)]);
      this.formGroup.controls['email'].setValidators([Validators.required, Validators.email, Validators.pattern(Patterns.email)]);
      this.formGroup.controls['role'].setValidators(this.currentUser ? [Validators.required] : []);
    }
    this.formGroup.controls['name'].updateValueAndValidity();
    this.formGroup.controls['email'].updateValueAndValidity();
    this.formGroup.controls['role'].updateValueAndValidity();
  }

  saveRecord() {
    this.isSubmitted = true;
    if (this.formGroup.valid && this.captcha) {
      this.loading = true;
      const controls = this.formGroup.controls;
      const formData = new FormData();
      const data = {
        IsAnonymous: controls['isAnonymous'].value,
        Name: controls['isAnonymous'].value ? null : controls['name'].value,
        Email: controls['isAnonymous'].value ? null : controls['email'].value,
        Role: controls['isAnonymous'].value ? null : controls['role'].value,
        SubmissionType: controls['submissionType'].value,
        SupportRequestCategoryId: controls['supportRequestCategoryId'].value,
        Description: controls['description'].value
      } as SupportTicketForm;
      if (this.attachments && this.attachments.length) {
        this.attachments.forEach((file: any) => {
          if (!file.id) {
            formData.append('files', file, file.name);
          }
        });
      }

      formData.append('data', JSON.stringify(data));

      this.service.submitTicket(formData, !!this.currentUser).subscribe((response: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        this.confirmation(controls['isAnonymous'].value, controls['submissionType'].value, response.InsertedValue);
      }, (err: any) => {
        this.loading = false;
        this.handleErrors(err.detail);
        this.scrollToFirstInvalidControl();
      });
    } else {
      this.formGroup.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }

  confirmation(isAnonymous: boolean, submissionType: SubmissionType, id: any) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '750px',
      data: {
        img: 'assets/images/icons/done_illustration.svg',
        title: submissionType == SubmissionType.Complaint ? this.translate.instant('supportTicket.complaintSubmittedSuccessfully') : this.translate.instant('supportTicket.suggestionSubmitted'),
        message: isAnonymous ? this.translate.instant('supportTicket.referenceNumberMessage', { id }) : '',
        btnTitle: this.translate.instant("trainee.done"),
        btnClass: 'larg-btn',
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {

      }
    });
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      if (error.ErrorCode === 'Repeated') {
        this.formGroup.controls[error.ErrorDetail].setErrors({ notUniqe: true });
      }
    });
  }

  public resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      'form .ng-invalid'
    );
    console.log(firstInvalidControl)
    firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }
}
